import GlobalSearch from './index.vue'

export default [
  {
    path: '/global-search',
    name: 'GlobalSearch',
    component: GlobalSearch
  }
]
